import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles, IconButton, Dialog, DialogTitle, DialogActions} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import { HeaderStyle } from './Header.style';
import NotificationsIcon from '@material-ui/icons/TuneRounded';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import MainMenu from './MainMenu';
import CloseIcon from '@material-ui/icons/CloseRounded';
import { ISchedule } from '@app-types/websocket/schedule.types';
import { ICalendarSetting } from '@app-types/websocket/user.types';
import { ISuggestion, IScheduleChange, ICreateSuggestion } from '@app-types/websocket/suggestion.types';
// import CordovaContext from '../../../cordovaContext';
import { SUGGESTION_TYPES,  HELP_TOPICS, SUGGESTION_CHANGE_TYPES } from '@constants/suggestionTypes';
import SCHEDULE_TYPES from '@constants/scheduleTypes';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';
import * as UserActions from '@services/user/user.actions';
import * as Suggestion from '@services/suggestion/suggestion.action';
import { secondaryColor, styleColors } from 'src/main.style';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { DialogTop } from '@components/economy/DialogComponens';
import EditMenu from './EditMenu';
import ShowChanges from '../suggestion/ShowChanges';
import AISchoolVacations from '../holidays/AISchoolVacations';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  histoyMenuOpen:boolean;
  highestScheduleIdAtStart:number|null;
  temporaryDismissedLongClick:boolean;
  suggestShareScheduleId:number|null;

  showSuggestionDetails:ISuggestion|undefined;
  showImportSchoolHolidays:boolean;
}

interface IProps extends WithStyles<typeof HeaderStyle> {
  currentYear:number; // to display in header
  currentMonth:number; // to display in header
  localization: "se"|"en";
  isEditing:boolean;
  suggestionId:number|undefined;
  isParent:boolean;

  setMonthSize:(size:"small"|"medium"|"large") => void;
  monthSize:"small"|"medium"|"large";

  totalSentSuggestions:number;
  totalReceivedSuggestions:number;
  totalSentSuggestionsNonActive:number;
  totalReceivedSuggestionsNonActive:number;
  selectedDays:IDateRange[];
  usedByErrorSchedules:number[];
  schedules:ISchedule[];
  suggestionsAwaitingMyReply:ISuggestion[];
  calendarSettings: ICalendarSetting;

  startEditing:(scheduleId:number, suggestionId:number) => void;
  cancelEditing:() => void;
  setSelectedDate: (year:number,month:number,date:number) => void;
  dismissHelpNotice: (notice:string) => void;
  makeNewSuggestionGuide: (scheduleId:number) => void;
  selectRange: (startOfStartday:number, endOfEndDay:number, days:boolean[]) => void;
  updateCalendarSettings: (data: ICalendarSetting) => void;
  createSuggestion: (data: ICreateSuggestion) => void;

  dismissedHelpSentSuggestion:boolean;
  dismissedHelpLongclick:boolean;
  dismissedClickEditDays:boolean;
  dismissedSelectMultipleDays:boolean;
  dismissedHowToMakeChanges:boolean;

  showWeekNumber:boolean;
  isTogether:boolean;
}

class Header extends React.Component<IProps, IState> {
  private editRef: React.RefObject<HTMLButtonElement>;
  private historyRef: React.RefObject<HTMLButtonElement>;
  constructor(props: IProps) {
    super(props);
    
    let highestScheduleIdAtStart:number|null = null;
    if (props.schedules && props.schedules.length > 0) {
      highestScheduleIdAtStart = props.schedules[0].id;
      for (const sched of props.schedules) {
        if (sched.id > highestScheduleIdAtStart) {
          highestScheduleIdAtStart = sched.id;
        }  
      }
    }

    let suggestShareScheduleId:number|null = null;
    if (props.schedules && props.calendarSettings && props.calendarSettings.calendars) {
      for (const schedule of props.schedules) {
        if (props.calendarSettings.calendars.includes(schedule.id) && schedule.status === SCHEDULE_TYPES.WIP) {
          suggestShareScheduleId = schedule.id;
        }
      }
    }

    this.historyRef=React.createRef();
    this.editRef=React.createRef();

    this.state = {
      histoyMenuOpen:false,
      highestScheduleIdAtStart,
      temporaryDismissedLongClick:false,
      suggestShareScheduleId,
      showSuggestionDetails:undefined,
      showImportSchoolHolidays:false,
    };

  }

  public componentDidUpdate(prevProps:IProps) {
    if (this.state.highestScheduleIdAtStart === null && prevProps.schedules !== this.props.schedules){
      let highestScheduleIdAtStart:number|null = null;
      if (this.props.schedules && this.props.schedules.length > 0) {
        highestScheduleIdAtStart = this.props.schedules[0].id;
        for (const sched of this.props.schedules) {
          if (sched.id > highestScheduleIdAtStart) {
            highestScheduleIdAtStart = sched.id;
          }  
        }
        this.setState({highestScheduleIdAtStart});
      }
    }
    if (this.state.suggestShareScheduleId === null && prevProps.calendarSettings !== this.props.calendarSettings 
      && this.props.calendarSettings.calendars) {
      let shareCal:number|null = null;
      for (const schedule of this.props.schedules) {
        if (this.props.calendarSettings.calendars.includes(schedule.id) && schedule.status === SCHEDULE_TYPES.WIP) {
          shareCal = schedule.id;
        }
      }
      if (shareCal) {
        this.setState({suggestShareScheduleId:shareCal});
      }
    }
  }

  public render() {
    const {classes, localization, isEditing, isParent} = this.props;

    const dayInitials:JSX.Element[] = [];

    if (this.props.showWeekNumber) {
      dayInitials.push(
        <div key={"weeknum"}  className={classes.dayInitial} style={{width:'21px', textTransform: 'lowercase'}}>
          {tn.lang.weekLabel.charAt(0)+"."}
        </div>);
    }

    for (let index = 0; index < 7; index++) {
      dayInitials.push(
        <div key={index} className={classes.dayInitial} style={this.props.showWeekNumber?{width:'calc((100% / 7) - 3px)'}:{}}>
          {tn.lang.getWeekdayName((index+(localization==="se"?1:0))%7).charAt(0)}
        </div>);
    }
    const highlightSchedules:number[] = [...this.props.usedByErrorSchedules]
    for (const sched of this.props.schedules) {
      if (this.state.highestScheduleIdAtStart !== null) {
        if (sched.id > this.state.highestScheduleIdAtStart 
          && sched.status !== SCHEDULE_TYPES.DELETED && sched.status !== SCHEDULE_TYPES.DELETED_WIP) {
          highlightSchedules.push(sched.id);
        }
      }
    }

    let showingHelp:boolean = false;

    let youHaveASuggestion:JSX.Element =  <div className={classes.snackBarHidden} key="sbtop"/>;
    if (!isEditing && this.props.totalReceivedSuggestions > 0 
      && this.props.calendarSettings.calendars && this.props.calendarSettings.calendars.length > 0) {
      let clickHandler:() => void = () => {return;}
      if (this.props.suggestionsAwaitingMyReply.length === 1 && this.props.suggestionsAwaitingMyReply[0].schedules.length === 1) {
        clickHandler = () => {this.props.startEditing(this.props.suggestionsAwaitingMyReply[0].schedules[0], 
          this.props.suggestionsAwaitingMyReply[0].id)};
      } 

      showingHelp = true;
      youHaveASuggestion = 
        <div onClick={clickHandler} className={classes.snackBar} style={{left:'62px', right: 'unset'}} key="sbtop">
          <InfoIcon className={classes.snackBarIcon}/>
          <span>{tn.lang.calSuggWaiting}</span>
          <div  className={classes.snackBarArrow} style={{right: 'unset', left: '-5px', 
            borderLeft: '0px', borderRight: '5px solid '+secondaryColor}}/>
        </div>;
    }


    const headerText = tn.lang.getMonthName(this.props.currentMonth) + " "+this.props.currentYear;
    let headerSubText = "";
    if (isEditing) {
      headerSubText = tn.lang.calSchedules;
    }

    let sentSuggestionsTip:JSX.Element|null = null;
    let longClickTip:JSX.Element|null = null;
    
    if (isParent && (!this.props.isTogether) && !showingHelp && isEditing 
      && this.props.suggestionId === 0 
      && !this.props.dismissedClickEditDays) {
      showingHelp = true;
      longClickTip = (
      <div className={classes.snackBarSentSuggestions+" "+classes.snackBar+" "+classes.snackBarWithImage}
        onClick={() => this.props.dismissHelpNotice(HELP_TOPICS.CLICK_EDIT_DAYS)}
        style={{top: '214px', right: '50%', transform: 'translateX(50%)'}}>
        <span style={{flex: 1}}>{tn.lang.calHelpClickEdit}</span>
        <CloseIcon className={classes.closeBarIcon}/>
        <img src="https://varannanvecka.app/edit-swe.gif" alt="" className={classes.snackBarImage}/>
        <div  className={classes.snackBarArrow} 
          style={{top: '-8px', right: 'calc(50% - 8px)', border: '8px solid transparent', 
            borderBottom: ("8px solid "+secondaryColor)}}/>
      </div>);
    }
    

    if (isParent && (!this.props.isTogether) && !showingHelp && !isEditing && this.props.totalSentSuggestions > 0 
      && !this.props.dismissedHelpSentSuggestion) {
      sentSuggestionsTip = (
      <div className={classes.snackBarSentSuggestions+" "+classes.snackBar} style={{right:'unset', left:'6px'}}
        onClick={() => this.props.dismissHelpNotice(HELP_TOPICS.WHERE_SENT_SUGGESTION)}>
        <span>{tn.lang.calHelpWhereSentSuggestion}</span>
        <CloseIcon className={classes.closeBarIcon}/>
        <div  className={classes.snackBarArrow} style={{top: '-8px', left: '19px', 
          border: '8px solid transparent', borderBottom: ("8px solid "+secondaryColor)}}/>
      </div>);
    }

    if (isParent && (!this.props.isTogether) && !showingHelp && !isEditing && !this.props.dismissedHowToMakeChanges) {
      sentSuggestionsTip = (
      <div className={classes.snackBarSentSuggestions+" "+classes.snackBar} style={{right:'unset', left:'6px'}}
        onClick={() => this.props.dismissHelpNotice(HELP_TOPICS.HOW_TO_MAKE_CALENDAR_CHANGES)}>
        <span>{tn.lang.calHelpBiggerChanges}</span>
        <CloseIcon className={classes.closeBarIcon}/>
        <div  className={classes.snackBarArrow} style={{top: '-8px', left: '19px', 
          border: '8px solid transparent', borderBottom: ("8px solid "+secondaryColor)}}/>
      </div>);
    }


    return (
    <div className={classes.header} style={isEditing?{backgroundColor:secondaryColor, color:'#FFFFFF'}:{color:styleColors.greyDark3}}>
      <div className={classes.headerTitle}>
        <span style={headerSubText !== ""?{lineHeight: '40px'}:{}}>{headerText}</span>
        <span style={{marginTop: '-28px',fontSize: '16px'}}>{headerSubText}</span>
      </div>
      <div className={classes.headerButtons}>
        
        {(isParent && (!this.props.isTogether)) 
          ? <EditMenu 
            isEditing={this.props.isEditing}
            startEditing={(scheduleId:number,suggestionId:number) => this.props.startEditing(scheduleId,suggestionId)}
            cancelEdit={this.props.cancelEditing}
            showDetails={(suggestion) => this.setState({showSuggestionDetails:suggestion})}
          />
          :<div/>}
        
        <div>

          {longClickTip}
          {sentSuggestionsTip}
          {youHaveASuggestion}

          <IconButton ref={this.historyRef} onClick={() => this.setState({histoyMenuOpen:true})}>
            <NotificationsIcon style={{fontSize:'24px', marginRight:'12px',
              fill: isEditing ? styleColors.whiteText82 : styleColors.greyDark1,
              opacity: isEditing ? 1 : 0.68}}/>
            <div style={{position:'absolute', display: 'flex', top: '6px', right: '6px'}}> { /* The badges */ }
              <span style={{backgroundColor:styleColors.handoverYellow}} className={classes.suggestionBadge
                +((highlightSchedules.length === 0 || isEditing)?(" "+classes.hiddenBadge):"")}>
                  {highlightSchedules.length}
              </span>
            </div>
          </IconButton>
        </div>
      </div>
      <div className={classes.weekInitials}>
        {dayInitials}
      </div>
      <MainMenu 
        isTogether={this.props.isTogether}
        showWeekNumber={this.props.showWeekNumber}
        isEditing={this.props.isEditing}
        open={this.state.histoyMenuOpen}
        reference={this.historyRef}
        close={() => this.setState({histoyMenuOpen:false})}
        setSelectedDate={this.props.setSelectedDate}
        setMonthSize={this.props.setMonthSize}
        monthSize={this.props.monthSize}
        makeNewSuggestionGuide={(scheduleId:number) => this.props.makeNewSuggestionGuide(scheduleId)}
        startEditing={(scheduleId:number,suggestionId:number) => this.props.startEditing(scheduleId,suggestionId)}
        totalSentSuggestionsNonActive={this.props.totalSentSuggestionsNonActive}
        totalReceivedSuggestionsNonActive={this.props.totalReceivedSuggestionsNonActive}
        usedByErrorSchedules={highlightSchedules}
        totalReceivedSuggestions={this.props.totalReceivedSuggestions}
        totalSentSuggestions={this.props.totalSentSuggestions}
        showDetails={(suggestion) => this.setState({showSuggestionDetails:suggestion})}
        setShowSchoolHolidays={(show:boolean) => this.setState({showImportSchoolHolidays:show})}
      />
      <AISchoolVacations open={this.state.showImportSchoolHolidays} close={() => this.setState({showImportSchoolHolidays:false})}/> 
      <Dialog
        open={ this.state.suggestShareScheduleId !== null && this.state.suggestShareScheduleId > 0}
        onClose={() => this.setState({ suggestShareScheduleId:0})}
      >
        <DialogTop>
          <DialogTitle>{tn.lang.newCalendar}</DialogTitle>
          <IconButton onClick={() => this.setState({ suggestShareScheduleId:0})}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <div style={{padding: '8px 24px', display: 'flex', flexDirection: 'column'}}>
          {tn.lang.calShareNewSchedule}
        </div>
        <DialogActions>
          <Button  variant='outlined' classes={{outlined:classes.buttonOutlined}} onClick={() => this.setState({ suggestShareScheduleId:0})} >
              {tn.lang.no}
          </Button>
          <Button  variant='contained' classes={{contained:classes.buttonContained}} color='primary' onClick={() => {
              if (this.state.suggestShareScheduleId !== null && this.state.suggestShareScheduleId > 0) {
                this.shareSchedule(this.state.suggestShareScheduleId);
              }
              this.setState({ suggestShareScheduleId:0});
            }}>
              {tn.lang.yes}
          </Button>
        </DialogActions>
      </Dialog>
      <ShowChanges
        open={ this.state.showSuggestionDetails !== undefined }
        close={() => this.setState({ showSuggestionDetails:undefined})}
        suggestion={this.state.showSuggestionDetails}
      />
    </div>);
  }

  private shareSchedule(scheduleId:number) {
    const mods:IScheduleChange[] = [];
    mods.push({
      scheduleId,
      type: SUGGESTION_CHANGE_TYPES.SHARE,
      isParentA: true,
      newScheduleEntry: undefined,
      oldScheduleEntry: undefined,
      children:undefined
    });

    const data: ICreateSuggestion = {
      changes: mods,
    };

    this.props.createSuggestion(data);

    if (this.state.highestScheduleIdAtStart === null || scheduleId > this.state.highestScheduleIdAtStart) {
      this.setState({highestScheduleIdAtStart:scheduleId});
    }

  }
}



function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  const family:IFamilyMember[] = state.family.family?state.family.family:[];

  const schedules:ISchedule[] =  state.schedule.schedules;
  const calendarSettings: ICalendarSetting = state.user.calendarSettings;
  
  let totalSentSuggestions:number = 0;
  let totalReceivedSuggestions:number = 0;
  let totalSentSuggestionsNonActive:number = 0;
  let totalReceivedSuggestionsNonActive:number = 0;
  const suggestions:ISuggestion[] = state.suggestion.suggestions?state.suggestion.suggestions:[];
  const awaitingMyReply:ISuggestion[] = [];

  for (const suggestion of suggestions) {
    if (suggestion.status === SUGGESTION_TYPES.AWAITING_APPROVAL) {
      const scheduleId = suggestion.schedules.length > 0? suggestion.schedules[0]:0;
      const schedule = schedules?schedules.find((sched) => sched.id === scheduleId):undefined;
      if (schedule && (schedule.status !== SCHEDULE_TYPES.DELETED && schedule.status !== SCHEDULE_TYPES.DELETED_WIP)) {
        if (suggestion.creatorId === userId) {
          totalSentSuggestions += 1;
          if (calendarSettings.calendars !== undefined && !calendarSettings.calendars.includes(scheduleId)) {
            totalSentSuggestionsNonActive += 1;
          }
        } else {
          totalReceivedSuggestions += 1;  
          if (calendarSettings.calendars !== undefined && !calendarSettings.calendars.includes(scheduleId)) {
            totalReceivedSuggestionsNonActive += 1;
          } else {
            awaitingMyReply.push(suggestion);
          }
        }
  
      }
    }
  }

  const usedByErrorSchedules:number[] = [];
  let parentACals:number[] = [];
  let parentBCals:number[] = [];
  let myCals:number[] = [];
  let isParent:boolean = false;
  let numActiveParents = 0;

  let foundOneParent = false;

  if (family) {
    for (const mem of family) {
      if (mem.id === userId) {
        if (mem.calendars) {
          myCals = [...mem.calendars];
        }
        if (mem.role === FamilyMemberType.PARENT) {
          isParent = true;
        }
      }
      if (mem.role === FamilyMemberType.PARENT) {
        if (mem.lastOnline && mem.lastOnline > 0) {
          numActiveParents++;
        }
        if (mem.calendars) {
          if (!foundOneParent) {
            parentACals = [...mem.calendars];
            foundOneParent= true;
          } else {
            parentBCals = [...mem.calendars];
          }
        }
      }
    }
  }



  if (numActiveParents > 1) {
    for (const calId of myCals) {
      if (!parentACals.includes(calId) && !usedByErrorSchedules.includes(calId)) {
        usedByErrorSchedules.push(calId);
      }
      if (!parentBCals.includes(calId) && !usedByErrorSchedules.includes(calId)) {
        usedByErrorSchedules.push(calId);
      }
    }
    if (myCals.length === 0) {
      usedByErrorSchedules.push(...parentACals);
      for (const calId of parentBCals) {
        if (!usedByErrorSchedules.includes(calId)) {
          usedByErrorSchedules.push(calId);
        }
      }
    }
    /*
    for (const calId of parentACals) {
      if (!myCals.includes(calId) && !usedByErrorSchedules.includes(calId)) {
        usedByErrorSchedules.push(calId);
      }
    }
    for (const calId of parentBCals) {
      if (!myCals.includes(calId) && !usedByErrorSchedules.includes(calId)) {
        usedByErrorSchedules.push(calId);
      }
    }
    */
  }

  const dismissedHelpMessages = state.user.dismissedHelpNotices;
  let dismissedHelpSentSuggestion = false;
  let dismissedHelpLongclick = false;
  let dismissedSelectMultipleDays = false;
  let dismissedClickEditDays = false;
  let dismissedHowToMakeChanges = false;
  if (dismissedHelpMessages) {
    if (dismissedHelpMessages.includes(HELP_TOPICS.LONGCLICK)) {
      dismissedHelpLongclick = true;
    }
    if (dismissedHelpMessages.includes(HELP_TOPICS.WHERE_SENT_SUGGESTION)) {
      dismissedHelpSentSuggestion = true;
    }
    if (dismissedHelpMessages.includes(HELP_TOPICS.CLICK_EDIT_DAYS)) {
      dismissedClickEditDays = true;
    }
    if (dismissedHelpMessages.includes(HELP_TOPICS.SELECT_MULTIPLE_DAYS)) {
      dismissedSelectMultipleDays = true;
    }
    if (dismissedHelpMessages.includes(HELP_TOPICS.HOW_TO_MAKE_CALENDAR_CHANGES)) {
      dismissedHowToMakeChanges = true;
    }
  }
  
  return {
    totalSentSuggestions,
    totalReceivedSuggestions,
    totalSentSuggestionsNonActive,
    totalReceivedSuggestionsNonActive,
    usedByErrorSchedules,
    suggestionsAwaitingMyReply:awaitingMyReply,
    schedules:state.schedule.schedules?state.schedule.schedules:[],
    dismissedHelpSentSuggestion,
    dismissedHelpLongclick,
    dismissedClickEditDays,
    dismissedSelectMultipleDays,
    dismissedHowToMakeChanges,
    calendarSettings,
    isParent,
  };
}

const mapDispatchToProps = {
  dismissHelpNotice:UserActions.dismissHelpNotice,
  updateCalendarSettings:UserActions.updateCalendarSettings,
  createSuggestion: Suggestion.createSuggestion,
};

// Header.contextType = CordovaContext;

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(HeaderStyle)(Header));



// WEBPACK FOOTER //
// ./src/components/calendar2/header/Header.tsx